import React, { FC, ReactNode } from "react";
import { iModalBodyProps } from "../../../../types/modalBoxType";

interface IProps  extends iModalBodyProps{
	className?: string
	children: ReactNode
}

const ModalBody: FC<IProps> = ({ children, className }) => {
	return (
		<>
			<div className={`modalBody ${className}`}>{children}</div>
		</>
	);
};
export default ModalBody;
